// Laadt een component pas als het voor het eerst getoond wordt (code splitting).
//
// Elk component krijgt zijn eigen <Suspense>, zodat alleen dát stuk van het scherm heel even
// leeg is tijdens het laden; de rest van de pagina blijft staan. Gebruik is gelijk aan een
// gewone import:
//
//   const Main = lazyComponent(() => import('./core/layout/Main'));
//   const ManageInvitedCustomers = lazyComponent(() => import('./CustomerPortal'), 'ManageInvitedCustomers');
//
// Na een nieuwe uitrol bestaan de oude JS-bestanden niet meer. Iemand die de site nog open had,
// krijgt dan een laadfout; in dat geval wordt de pagina één keer opnieuw geladen. Lukt het daarna
// nog steeds niet, dan volgt de gewone foutafhandeling (geen eindeloos herladen).
import React, { Suspense, forwardRef, lazy } from 'react';

const RELOAD_KEY = 'afterbase:chunk-reload-at';
const RELOAD_INTERVAL_MS = 30000; // nooit vaker dan eens per 30 seconden herladen (geen herlaadlus)

function isChunkError(err) {
  const text = `${err && err.name} ${err && err.message}`;
  return /ChunkLoadError|Loading chunk|Loading CSS chunk|dynamically imported module|Importing a module script failed/i.test(text);
}

function loadWithReload(loader) {
  return loader().catch((err) => {
    let last = 0;
    try { last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0; } catch (e) { /* geen opslag beschikbaar */ }
    if (isChunkError(err) && Date.now() - last > RELOAD_INTERVAL_MS) {
      try { sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch (e) { /* idem */ }
      window.location.reload();
      return new Promise(() => {}); // wacht op het herladen
    }
    throw err;
  });
}

export function lazyComponent(loader, exportName = 'default', fallback = null) {
  const Lazy = lazy(() => loadWithReload(loader).then((mod) => ({ default: mod[exportName] })));
  const Wrapped = forwardRef((props, ref) => (
    <Suspense fallback={fallback}>
      <Lazy {...props} ref={ref} />
    </Suspense>
  ));
  Wrapped.displayName = `Lazy(${exportName})`;
  return Wrapped;
}

export default lazyComponent;
